module.exports = __webpack_public_path__ + "s/img/Glam_M_5.cbf43a9c.jpg";